// extracted by mini-css-extract-plugin
module.exports =  {"container":"List-CCfL__container","spinner":"List-qeCD__spinner","save-container":"List-MxfB__save-container","synonyms":"List-CoJM__synonyms"};